export class PasswordUpdatePendingError extends Error {
	static get name() {
		return 'PasswordUpdatePendingError';
	}
	constructor(...params) {
		super(...params);
	}
}
